/* global Swiper */

document.querySelectorAll( '.b-resource-box-container--is-carousel' ).forEach( ( block ) => {

	let prevButton = null;
	let nextButton = null;


	if ( block.id ) {

		const sliderController = document.querySelector( `[data-slider-id="${block.id}"]` );
		if ( sliderController ) {

			prevButton = sliderController.querySelector( '.b-intro__slider-button--prev' )
			nextButton = sliderController.querySelector( '.b-intro__slider-button--next' )

		}

	}

	const slider = block.querySelector( '.swiper' )

	if ( slider ) {

		let swiperBreakpoints = {}
		const layoutElement = slider.querySelector( '.b-resource-box-container-grid' );

		if ( layoutElement.classList.contains( 'b-resource-box-container-grid--3' ) ) {

			swiperBreakpoints = {
				0: {
					slidesPerView: 1.05,
					spaceBetween: 12,
				},
				576: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
				768: {
					spaceBetween: 20,
					slidesPerView: 2,
				},
				1024: {
					spaceBetween: 24,
					slidesPerView: 3,
				}
			}

		} else {

			swiperBreakpoints = {
				0: {
					slidesPerView: 1.05,
					spaceBetween: 12,
				},
				576: {
					slidesPerView: 2,
					spaceBetween: 16,
				},
				768: {
					spaceBetween: 20,
					slidesPerView: 2,
				},
				1024: {
					spaceBetween: 24,
					slidesPerView: 2,
				}
			}

		}

		new Swiper( slider, {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 12,
			watchOverflow: true,
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
			breakpoints: swiperBreakpoints,
		} );

	}


} )

